/** Parse a Curo / Progeny account GUID from pasted text or Dynamics URL. */
export function parseCuroAccountId(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed) return null;

  const urlMatch = trimmed.match(/[?&]id=([0-9a-fA-F-]{36})/i);
  if (urlMatch?.[1]) return urlMatch[1].toLowerCase();

  if (
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i.test(
      trimmed,
    )
  ) {
    return trimmed.toLowerCase();
  }

  return null;
}
